import React, { lazy } from 'react';

const ContactFormBookEvent = lazy(() => import('./ContactFormBookEvent'));

interface ContactFormProps {
    onClose: () => void;
}

export const ContactFormBookEventLazy: React.FC<ContactFormProps> = (props) => {
    return (
        <React.Suspense fallback={<div>Loading...</div>}>
            <ContactFormBookEvent {...props} />
        </React.Suspense>
    );
};
